<template>
  <div class="exhibit-hall">
    <div v-if="isFetching" class="page-loader">
      <c-loader/>
    </div>

    <div v-else>
<!--      <page-title>Exhibit Hall</page-title>-->

      <div v-for="(group, groupIndex) in sponsorsGroup" class="category" :key="`sponsor-group-${groupIndex}`">
        <div class="category__name">{{ group.name }}</div>
        <div class="category__description">{{ group.description }}</div>

        <ul class="sponsors">
          <li
              v-for="(sponsor, sponsorIndex) in group.sponsors"
              class="sponsor"
              :key="`sponsor-${sponsorIndex}`"
              @click="handleSponsorClick(sponsor)"
          >
            <img
                v-if="sponsor.photo_url"
                :src="sponsor.photo_url"
                class="sponsor__avatar"
                width="300"
                :alt="sponsor.name"
            />
            <div v-else>
              <c-avatar-plug
                  borderRadius="0"
                  letterSize="90px"
                  height="200"
                  :letter="sponsor.name[0]"
              />
            </div>
            <h3 class="sponsor__title">
              <span>{{ sponsor.name }}</span>
            </h3>
            <div class="sponsor__short_description">{{ truncateText(sponsor.short_description, 300) }}</div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {truncateText} from "../../../global-declare-components/helpers/truncateText";
import common from "../../helpers/common";
import Container from "../../components/ui/Container";
import PageTitle from "../../components/ui/PageTitle";
import Notify from "../../components/ui/Notify";

export default {
  components: {
    Container,
    PageTitle,
    Notify,
  },
  mounted() {
    common.setHeaderText('Exhibit Hall');

    if (!this.hasFetchedSponsors) {
      this.$store.dispatch("sponsorsStore/fetchSponsors", {id: this.attendeeId});
    }
  },
  data() {
    return {
      attendeeId: this.$route.params.attendeeId
    }
  },
  computed: {
    ...mapGetters('sponsorsStore', [
      'sponsorsGroup',
      'isFetching',
      'hasFetchedSponsors'
    ]),
  },
  methods: {
    truncateText(...arg) {
      return truncateText(...arg);
    },

    handleSponsorClick(sponsor) {
      if (sponsor.sponsor_landing_url) {
        this.$router.push({name: "Exhibit Hall Sponsor View", params: {sponsorId: sponsor.id}})
        // window.location.href = `${sponsor.sponsor_landing_url}?attendeeId=${this.attendeeId}`;
        // window.open(sponsor.sponsor_landing_url, '_blank').focus();
      }

      return false;
    }
  }
}
</script>

<style lang="scss" scoped>
.sponsors {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: var(--attendee-gap-md);

  @media (max-width: 1100px) {
    grid-template-columns: 1fr 1fr 1fr;
  }

  @media (max-width: 900px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
}

.category {
  margin-bottom: var(--attendee-gap-xl);

  &__name {
    color: var(--attendee-text-primary-color);
    font-size: 21px;
    font-weight: 600;
  }

  &__description {
    color: var(--attendee-text-secondary-color);
    margin-bottom: var(--attendee-gap-md);
    font-size: 14px;
  }
}

.exhibit-hall {
  background-color: white;
  border-radius: var(--attendee-card-border-radius);
  padding: var(--attendee-gap-md);
}

.sponsor {
  box-shadow: var(--attendee-box-shadow);
  padding: var(--attendee-gap-md);
  border-radius: var(--attendee-card-border-radius);
  position: relative;
  cursor: pointer;

  &__avatar {
    object-fit: contain;
    width: 100%;
    height: 200px;
    display: block;
  }

  &__title {
    margin-bottom: var(--attendee-gap-sm);
    margin-top: var(--attendee-gap-sm);
    text-align: center;

    a, span {
      color: var(--attendee-text-primary-color);
      font-size: 21px;
    }
  }

  &__short_description {
    text-align: center;
    color: var(--attendee-text-primary-color);
  }
}
</style>
